import React from "react"
import { withRouter, Route } from "react-router-dom"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Loader from "react-loader-spinner"
import queryString from "query-string"
import dayjs from "dayjs"
import Actions from "../../Redux/Actions"
import colors from "../../Constants/colors"
import { ADDITIONAL_COURSE_ID } from "../../Constants/courses"
// Components
import PYPModuleSplashContainer from "../PYPModuleSplashContainer/PYPModuleSplashContainer"
import PYPPartContainer from "../PYPPartContainer/PYPPartContainer"

import GoogleTagManager from "../GoogleTagManager/GoogleTagManager"
import InvisibleGuideCompletion from "../InvisibleGuideCompletion/InvisibleGuideCompletion"
import PYPModal from "../PYPModal/PYPModal"

const moment = dayjs

const resolveWorkshopCourseContext = (location, user) => {
  const qs = queryString.parse(location.search)
  const courseIdFromQuery = qs.courseId ? Number(qs.courseId) : null
  const courseId = location.state?.courseId ?? courseIdFromQuery ?? null
  let courseName = location.state?.courseName

  if (!courseName && Number(courseId) === ADDITIONAL_COURSE_ID) {
    const enrolled = user?.enrolled_courses?.find(
      (c) => Number(c.id) === ADDITIONAL_COURSE_ID
    )
    courseName = enrolled?.name
  }

  if (!courseName) {
    courseName = "Pursue Your Purpose"
  }

  return { courseId, courseName }
}

class PursueYourPurpose extends React.Component {
  constructor() {
    super()
    this.setDimensions = this.setDimensions.bind(this)
    this.initWorkshop = this.initWorkshop.bind(this)
  }

  initWorkshop() {
    const { courseId, courseName } = resolveWorkshopCourseContext(
      this.props.location,
      this.props.user
    )
    document.title = courseName
    this.props.initializePYP(
      this.props.match.params.module,
      courseName,
      courseId
    )
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentPartTitle !== this.props.currentPartTitle) {
      document.getElementById("Content-Container").scrollTop = 0
    }
    if (prevProps.match.params.module !== this.props.match.params.module) {
      this.props.navigateToModule(this.props.match.params.module)
    }

    const prevCourse = resolveWorkshopCourseContext(
      prevProps.location,
      prevProps.user
    )
    const nextCourse = resolveWorkshopCourseContext(
      this.props.location,
      this.props.user
    )
    if (Number(prevCourse.courseId) !== Number(nextCourse.courseId)) {
      this.initWorkshop()
    }

    if (
      !prevProps.pypIsInitialized &&
      this.props.pypIsInitialized &&
      /\/content/.test(this.props.location.pathname)
    ) {
      this.props.initializePYPPart(this.props.match, this.props.history)
    }

    const navigatedToContent =
      !/\/content/.test(prevProps.location.pathname) &&
      /\/content/.test(this.props.location.pathname)

    const moduleChangedOnContent =
      prevProps.match.params.module !== this.props.match.params.module &&
      /\/content/.test(this.props.location.pathname)

    if (
      this.props.pypIsInitialized &&
      (navigatedToContent || moduleChangedOnContent)
    ) {
      this.props.initializePYPPart(this.props.match, this.props.history)
    }

    if (
      prevProps.currentCourseName !== this.props.currentCourseName &&
      this.props.currentCourseName
    ) {
      document.title = this.props.currentCourseName
    }
  }

  componentDidMount() {
    if (queryString.parse(this.props.location.search).click === "true") {
      const { emailId } = queryString.parse(this.props.location.search)
      this.props.emailClicked({ emailId })
    }
    this.initWorkshop()
  }

  setDimensions() {
    try {
      if (typeof window !== "undefined" && !window.dataLayer) {
        window.dataLayer = []
      }

      if (window.dataLayer) {
        window.dataLayer.push({
          dimensions: {
            rank:
              this.props.user &&
              this.props.user.military &&
              this.props.user.military.lastRank,
            USSOCOM:
              this.props.user &&
              this.props.user.military &&
              this.props.user.military.sof,
            time_until_separation:
              this.props.user &&
              this.props.user.military &&
              `${moment(this.props.user.military.retirementDate).diff(
                moment(),
                "months"
              )} Months`,
            military_status:
              this.props.user &&
              this.props.user.military &&
              this.props.user.military.status,
            gender: this.props.user && this.props.user.gender
          }
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  render() {
    if (this.props.pypIsInitialized) {
      return (
        <GoogleTagManager
          gtmId={process.env.REACT_APP_PYP_GTM_ID}
          onFinishLoad={this.setDimensions}
        >
          <InvisibleGuideCompletion GUIDE_USI="LANDING_PAGE_PYP" />
          <Route
            exact
            path="/workshop/:module/content"
            render={() => <PYPPartContainer />}
          />
          <Route
            exact
            path="/workshop/:module"
            render={() => {
              return <PYPModuleSplashContainer />
            }}
          />
          <PYPModal />
        </GoogleTagManager>
      )
    }
    return (
      <div style={styles.loader}>
        <Loader type="Oval" color={colors.midnight} height="100" width="100" />
      </div>
    )
  }
}

const styles = {
  loader: {
    width: "100%",
    height: "calc(100vh)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    pypIsInitialized: state.pyp.initialized,
    user: state.user.user,
    currentCourseName: state.pyp.navigation.currentCourseName,
    currentPartTitle:
      state.pyp.parts &&
      state.pyp.navigation.currentPartId > -1 &&
      state.pyp.parts.byId[state.pyp.navigation.currentPartId] &&
      state.pyp.parts.byId[state.pyp.navigation.currentPartId].name
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PursueYourPurpose)
)
